<template>
  <div>
    <div class="row">
      <div class="col-md-12">
        <KTCodePreview v-bind:title="'Master Bobot Jawaban Diklat'">
          <template v-slot:toolbar>
            <ButtonComponent colors="#3751E4" name="tambah" v-b-modal.modal @click.native="openModal('Tambah')" />
          </template>
          <template v-slot:body>
            <v-row>
              <v-col>
                <SelectBidangStudi></SelectBidangStudi>
              </v-col>
              <v-col>
                <SelectMataKuliah></SelectMataKuliah>
              </v-col>
            </v-row>
            <v-card-title>
              <v-spacer></v-spacer>
              <v-text-field v-model="code1.search" label="Search" single-line hide-details></v-text-field>
            </v-card-title>
            <v-data-table :headers="code1.headers" :items="code1.desserts" :search="code1.search">
              <template v-slot:item.action="{ item }">
                <ButtonComponent colors="#3751E4" name="edit" v-b-modal.modal @click.native="openModal('Edit')" />
                <ButtonComponent colors="#EF4848" name="hapus" />
              </template>
            </v-data-table>
          </template>
        </KTCodePreview>

        <b-modal ok-title="Simpan" ok-variant="primary" cancel-title="Batal" cancel-variant="danger" id="modal"
          :title="`${statusModal} Mata Pelajaran`">
          <b-form>
            <b-form-group label="Bidang Studi :" label-for="input-1">
              <Select2 v-model="myValue" :options="options" :settings="{ multiple: false, width: '100%' }" />
            </b-form-group>

            <b-form-group label="Mata Kuliah :" label-for="input-1">
              <Select2 v-model="myValue" :options="optionsMK" :settings="{ multiple: false, width: '100%' }" />
            </b-form-group>

            <b-form-group label="Kode :" label-for="input-1">
              <b-form-input id="input-1" type="number" required></b-form-input>
            </b-form-group>
            <b-form-group label="Nama Mata Pelajaran :" label-for="input-1">
              <b-form-input id="input-1" type="text" required></b-form-input>
            </b-form-group>
          </b-form>
        </b-modal>
      </div>
    </div>
  </div>
</template>

<script>
import KTCodePreview from "@/view/content/CardContent.vue";
import ButtonComponent from "@/view/content/components/button/buttonComponent.vue";
import { SET_BREADCRUMB } from "@/core/services/store/breadcrumbs.module";
import SelectBidangStudi from "@/view/content/components/select/SelectBidangStudi.vue"
import SelectMataKuliah from "@/view/content/components/select/SelectMataKuliah.vue";
import Select2 from 'v-select2-component';

export default {
  data() {
    return {
      code1: {
        search: "",
        headers: [
          { text: "No", value: "no", align: "center" },
          { text: "Kode", value: "kode", align: "center" },
          { text: "Mata Pelajaran", value: "mataPelajaran", align: "center" },
          { text: "Aksi", value: "action", align: "center" }
        ],
        desserts: [
          {
            no: 1,
            kode: "BS 001 MK001 MP004",
            mataPelajaran: "Pembekalan Kode Pops",
          },
          {
            no: 2,
            kode: "BS 001 MK001 MP002",
            mataPelajaran: "Pembekalan Kadiptek",
          },
          {
            no: 3,
            kode: "BS 001 MK001 MP003",
            mataPelajaran: "Pembekalan Dirdik",
          },
          {
            no: 4,
            kode: "BS 001 MK001 MP004",
            mataPelajaran: "Pembekalan Kordos",
          },
          {
            no: 5,
            kode: "BS 001 MK001 MP005",
            mataPelajaran: "Pembekalan Kadepjemen",
          }
        ]
      },
      options: [
        { text: 'Bidang Studi Operasi', id: 5 },
        { text: "Bidang Studi Manajemen dan Logistik", id: 4 },
        { text: "Bidang Studi Kepemimpinan dan Kejuangan", id: 3 },
        { text: "Bidang Studi Strategi", id: 2 },
        { text: "Bidang Studi Manajemen dan Logistik", id: 1 },
        { text: "Bidang Studi Ilmu Pengetahuan dan Teknologi", id: 0 },
      ],
      optionsMK: [
        { text: "Aplikasi Komputer", id: 3 },
        { text: "Matematika Diskret", id: 2 },
        { text: "Arsitektur Komputer", id: 1 },
        { text: "Probabilitas Statistika", id: 0 }
      ],
      statusModal: '',
      myValue: ''
    };
  },
  components: {
    KTCodePreview,
    SelectBidangStudi,
    SelectMataKuliah,
    ButtonComponent,
    Select2
  },
  mounted() {
    this.$store.dispatch(SET_BREADCRUMB, [
      { title: "Akademik" },
      { title: "Master Mata Pelajaran" }
    ]);
  },
  methods: {
    openModal(status) {
      this.statusModal = status
    }
  }
}
</script>